import { useState } from 'react';

/** Whether a catalogue's create/edit drawer is open, and which row it edits (none = a new one). */
export function useCatalogueDrawer<Row>(resetSaveError: () => void) {
  const [isOpen, setIsOpen] = useState(false);
  const [editing, setEditing] = useState<Row | undefined>(undefined);

  function open(row?: Row) {
    resetSaveError();
    setEditing(row);
    setIsOpen(true);
  }

  return { isOpen, editing, open, close: () => setIsOpen(false) };
}
